module.exports = __webpack_public_path__ + "media/图1-33动画.1bc2b15c.mp4";